import { ICacheContext } from 'framework/context/ICacheContext';
import { IPurchasesFilterData } from 'gen/ApiClient';
import React from 'react';

export const PurchasesFilterDataContext = React.createContext<ICacheContext<IPurchasesFilterData>>(undefined as any);
